import EventsPage from "./ui/EventsPage.vue";
export default EventsPage;
